import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import RealTimePower from "@/pages/RealTimePower.vue";
import Comparison from "@/pages/Comparison.vue";
import Icons from "@/pages/Icons.vue";
import Environment from "@/pages/Environment.vue";
import Cost from "@/pages/Cost.vue";
import CarbonFootprint from "@/pages/CarbonFootprint.vue";
import Notifications from "@/pages/Notificationos.vue";
import HAC from "@/pages/HAC.vue";
import Admin from "@/pages/Admin/Admin.vue";
import Account from "@/pages/Admin/Account";
import ManageLinkedSites from '@/pages/Admin/ManageLinkedSites';
import ChannelType from "@/pages/Admin/ChannelType";
import Rates from "@/pages/Admin/Rates";
import EditSite from "@/pages/Admin/Edit/EditSite";
import EditChannel from "@/pages/Admin/Edit/EditChannel";
import Login from "@/pages/Auth/Login";
import ForgotPassword from "@/pages/Auth/ForgotPassword";
import ResetPassword from "@/pages/Auth/ResetPassword";
import EditGroup from "@/pages/Admin/Edit/EditGroup";
import Status from "@/pages/Status.vue";
import ChannelStatus from "@/components/Cards/ChannelStatusCard";


const routes = [
	{
		path: "/",
		component: DashboardLayout,
		redirect: "/dashboard",
		meta: { requiresAuth: true },
		children: [
			{
				path: "dashboard",
				name: "dashboard",
				meta: {
					isAdmin: false,
				},
				component: Dashboard,
			},
			{
				path: "status",
				name: "status",
				meta: {
					isAdmin: true,
				},
				component: Status,
			},
			{
				path: "site/:id/channel-status",
				name: "channel_status",
				meta: {
					isAdmin: true,
				},
				component: ChannelStatus,
			},
			{
				path: "notifications",
				name: "notifications",
				meta: {
					isAdmin: false,
				},
				component: Notifications,
			},
			{
				path: "realtimepower",
				name: "realtimepower",
				meta: {
					isAdmin: false,
				},
				component: RealTimePower,
			},
			{
				path: "comparison",
				name: "comparison",
				meta: {
					isAdmin: false,
				},
				component: Comparison,
			},
			{
				path: "icons",
				name: "icons",
				meta: {
					isAdmin: false,
				},
				component: Icons,
			},
			{
				path: "environment",
				name: "environment",
				meta: {
					isAdmin: false,
				},
				component: Environment,
			},
			{
				path: "cost",
				name: "cost",
				meta: {
					isAdmin: false,
				},
				component: Cost,
			},
			{
				path: "carbon_footprint",
				name: "carbon_footprint",
				meta: {
					isAdmin: false,
				},
				component: CarbonFootprint,
			},
			{
				path: "hvac",
				name: "hvac",
				meta: {
					isAdmin: false,
				},
				component: HAC,
			},
			{
				path: "admin",
				name: "admin",
				meta: {
					isAdmin: true,
				},
				component: Admin,
			},
			{
				path: "admin/account",
				name: "account",
				meta: {
					isAdmin: true,
				},
				component: Account,
			},
			{
				path: "admin/channeltypes",
				name: "channeltypes",
				meta: {
					isAdmin: true,
				},
				component: ChannelType,
			},
			{
				path: "admin/rates",
				name: "rates",
				meta: {
					isAdmin: true,
				},
				component: Rates,
			},
			{
				path: "admin/manage-linked-sites",
				name: "manageLinkedSites",
				meta: {
					isAdmin: true,
				},
				component: ManageLinkedSites,
			},
			{
				path: "admin/site/:id/edit",
				name: "edit_site",
				meta: {
					isAdmin: true,
				},
				component: EditSite,
			},
			{
				path: "admin/channel/:id/edit",
				name: "edit_channel",
				meta: {
					isAdmin: true,
				},
				component: EditChannel,
			},
			{
				path: "admin/circuit-group/:id",
				name: "edit_group",
				meta: {
					isAdmin: true,
				},
				component: EditGroup,
			},
		],
	},
	{ path: "/login", component: Login, meta: { guest: true } },
	{ path: "/forgot-password", component: ForgotPassword, meta: { guest: true } },
	{ path: "/reset-password", component: ResetPassword, meta: { guest: true } },
	{ path: "*", component: NotFound },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
